/**
 * Pure copy selector for the closed-project banner.
 *
 * Kept outside the React component so unit tests do not need to import the
 * component tree or UI primitives.
 */
export function closureBannerMessage(isAdmin: boolean): string {
  return isAdmin
    ? 'You retain full edit access on closed projects. Use Reopen at the top of this page to bring it back into an active state.'
    : 'This project is read-only for you. Ask an Admin to reopen the project if changes are needed.';
}
